import { useState, useEffect } from 'react';

const TOKEN_KEY = 'hub_admin_token';
const CHANGE_EVENT = 'hub:adminModeChanged';

function isTokenValid(token) {
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

// 로그인 성공 후 호출: localStorage(편집 모드) + sessionStorage(관리자 콘솔) 동시 저장
export function activateAdminMode(token) {
  localStorage.setItem(TOKEN_KEY, token);
  sessionStorage.setItem(TOKEN_KEY, token);
  window.dispatchEvent(new Event(CHANGE_EVENT));
}

export default function useAdminMode() {
  const [isAdmin, setIsAdmin] = useState(() => isTokenValid(localStorage.getItem(TOKEN_KEY)));

  useEffect(() => {
    const check = () => setIsAdmin(isTokenValid(localStorage.getItem(TOKEN_KEY)));
    const timer = setInterval(check, 30000);
    window.addEventListener(CHANGE_EVENT, check);
    return () => {
      clearInterval(timer);
      window.removeEventListener(CHANGE_EVENT, check);
    };
  }, []);

  function exitAdminMode() {
    localStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
    window.location.reload();
  }

  return { isAdmin, exitAdminMode };
}
